import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    scroll(event) {
        event.preventDefault();
        const target = event.target.getAttribute('href').substring(1);
        this.smoothScroll(target);
    }

    smoothScroll(target) {
        const element = document.getElementById(target);
        if (element) {
            window.scrollTo({
                top: element.offsetTop,
                behavior: 'smooth'
            });
        }
    }
}
